import { getMyUser } from "@/user/api/UserApi"
import { User } from "@/user/model/UserModel"
import { defineStore } from "pinia"
import { reactive, ref, computed } from "vue"
import { useOrderNotificationStore } from "@/store/OrderNotificationStore"

export const useUserStore = defineStore("user", () => {
  const savedUser = localStorage.getItem("user")
  const state = reactive({
    user: savedUser ? (JSON.parse(savedUser) as User) : {
      id: "",
      name: "",
      email: "",
      phone: "",
      isAdmin: false,
      avatarUrl: "",
    } as User,
    auth: {
      accessToken: "",
      refreshToken: "",
    },
  })

  const auth = computed(() => state.auth)

  const user = computed(() => state.user)

  const getAccessToken = () => {
    return {
      accessToken: localStorage.getItem("accessToken") || "",
      refreshToken: localStorage.getItem("refreshToken") || "",
    }
  }

  const login = (accessToken: string, refreshToken: string) => {
    auth.value.accessToken = accessToken
    auth.value.refreshToken = refreshToken
    localStorage.setItem("accessToken", accessToken)
    localStorage.setItem("refreshToken", refreshToken)
  }

  const refreshToken = (accessToken: string) => {
    auth.value.accessToken = accessToken
    localStorage.setItem("accessToken", accessToken)
  }

  const signout = () => {
    auth.value.accessToken = ""
    auth.value.refreshToken = ""
    localStorage.setItem("accessToken", "")
    localStorage.setItem("refreshToken", "")
    useOrderNotificationStore().destroyAll()
    localStorage.removeItem("user")
  }

  const reloadUser = async () => {
    try {
      state.user = await getMyUser()
      localStorage.setItem("user", JSON.stringify(state.user))
    } catch (error) {
      return error
    }
  }

  return {
    user,
    auth,
    getAccessToken,
    reloadUser,
    login,
    refreshToken,
    signout,
  }
})
